export {EventEmitter} from './EventEmitter';
export type {EventListeners} from './types';
